export enum MediaType {
  IMAGE = 'image',
  YOUTUBE = 'youtube',
  HEXA3D = 'hexa3d',
}

export enum ProductStatus {
  ACTIVE = 'Active',
  ARCHIVED = 'Archived',
  DRAFT = 'Draft',
}

export interface IProduct {
  id?: number;
  title: string;
  previewImage?: { url: string };
  userId: number;
  tourId: number;
  description: string;
  countryId: number;
  weight: number;
  weightUnit: string;
  isTrackQuantity?: boolean;
  quantity?: number;
  sellingOutOfStock?: boolean;
  barcode: string;
  sku: string;
  price: number;
  comparePrice: number;
  isShipping: boolean;
  hsCode: string;
  warrantyFile: string;
  specificationsFile: string;
  eCommerceVendorId: number;
  eCommerceProductTypeId: number;
  isMultipleOptions: boolean;
  icon?: string;
  iconFile?: string;
  opacity?: number;
  iconColor?: string;
  sid: string;
  positionX: number;
  positionY: number;
  positionZ: number;
  stemVectorX: number;
  stemVectorY: number;
  stemVectorZ: number;
  media?: any[];
  specifications: any[];
  options?: any[];
  variants?: any[];
  status: ProductStatus;
}

export class Product implements IProduct {
  id?: number;

  title: string;

  tourId: number;

  userId: number;

  description: string;

  countryId: number;

  status: ProductStatus;

  weight: number;

  weightUnit: string;

  isTrackQuantity?: boolean;

  quantity?: number;

  sellingOutOfStock?: boolean;

  barcode: string;

  sku: string;

  price: number;

  comparePrice: number;

  isShipping: boolean;

  hsCode: string;

  warrantyFile: string;

  specificationsFile: string;

  eCommerceVendorId: number;

  eCommerceProductTypeId: number;

  isMultipleOptions: boolean;

  icon?: string;

  iconFile?: string;

  opacity?: number;

  iconColor?: string;

  sid: string;

  positionX: number;

  positionY: number;

  positionZ: number;

  stemVectorX: number;

  stemVectorY: number;

  stemVectorZ: number;

  media?: any[];

  specifications: any[];

  options?: any[];

  variants?: any[];

  previewImage?: { url: string };

  isEnableCart: boolean;

  cartLink: string;

  cartLinkType: string;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.tourId = model.tourId || null;
    this.title = model.title || null;
    this.previewImage = model.previewImage || null;
    this.userId = model.userId || null;
    this.description = model.description || null;
    this.variants = model.variants || [];
    const customVariant = this.getMinVariant(model.variants, 'price');

    this.countryId = customVariant?.countryId || null;
    // this.status = customVariant?.status || null;
    this.weight = customVariant?.weight || null;
    this.weightUnit = customVariant?.weightUnit || null;
    this.isTrackQuantity = customVariant?.isTrackQuantity || false;
    this.quantity = customVariant?.quantity || 0;
    this.sellingOutOfStock = customVariant?.sellingOutOfStock || false;
    this.barcode = customVariant?.barcode || null;
    this.price = customVariant?.price || null;
    this.comparePrice = customVariant?.comparePrice || null;
    this.isShipping = customVariant?.isShipping || false;
    this.hsCode = customVariant?.hsCode || null;

    this.warrantyFile = model.warrantyFile || null;
    this.specificationsFile = model.specificationsFile || null;
    this.eCommerceVendorId = model.eCommerceVendorId || null;
    this.eCommerceProductTypeId = model.eCommerceProductTypeId || null;
    this.isMultipleOptions = model.isMultipleOptions || false;
    this.icon = model.icon || null;
    if (model.icon && model.icon?.indexOf('.') !== -1) {
      this.iconFile = `${process.env.REACT_APP_AWS}/users/${this.userId}/eCommerce/${this.id}/${model.icon}`;
      this.icon = null;
    }
    this.opacity = model.opacity || 0;
    this.iconColor = model.iconColor || null;
    this.media =
      model.media?.map((item: any) => ({
        ...item,
        url: this.getMediaUrl(item.url, item.type),
        embed: item.type === MediaType.YOUTUBE ? item.url : '',
      })) || [];

    this.specifications = model.specifications || [];
    this.options = model.options || [];

    this.previewImage = this.media.find((item) => item.type !== MediaType.YOUTUBE && item.type !== MediaType.HEXA3D) || {};
    this.sid = model.sid || null;
    this.positionX = model.positionX || null;
    this.positionY = model.positionY || null;
    this.positionZ = model.positionZ || null;
    this.stemVectorX = model.stemVectorX || null;
    this.stemVectorZ = model.stemVectorZ || null;
    this.stemVectorY = model.stemVectorY || null;
    this.status = model.status || null;

    this.isEnableCart = model.isEnableCart ?? false;
    this.cartLink = model.cartLink || '#';
    this.cartLinkType = model.cartLinkType || null;
  }

  getMediaUrl(url: string, type: string) {
    if (type === MediaType.YOUTUBE) {
      return `https://img.youtube.com/vi/${url}/sddefault.jpg`;
    }
    if (type === MediaType.HEXA3D) {
      return url;
    }
    return `${process.env.REACT_APP_AWS}/users/${this.userId}/eCommerce/${this.id}/media/${url}`;
  }

  // eslint-disable-next-line class-methods-use-this
  getMinVariant(data: any[] = [], field: string) {
    if (!data.length) return null;
    const filtered = data.filter((item) => (data.length > 1 && !item.isDefault) || data.length === 1);
    return filtered.reduce((minItem, item) => (item[field] != null && minItem[field] > item[field] ? item : minItem), filtered[0]);
  }
}
